<app-header></app-header>
<router-outlet />
<app-footer></app-footer>
<app-mobile-bar></app-mobile-bar>
